import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ShieldCheck, ClipboardCheck, MessageCircle, ArrowRight } from 'lucide-react';

const items = [
  { icon: FileText, label: 'Policies & procedures' },
  { icon: ClipboardCheck, label: 'Permits' },
  { icon: ShieldCheck, label: 'Clearances' },
  { icon: MessageCircle, label: 'General advice' },
];

const ComplianceServicesStrip = () => {
  return (
    <section className="bg-white py-8 sm:py-12 md:py-16" data-testid="compliance-services-strip">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#1e3a5f] via-[#254d7f] to-[#0f2340] text-white">
          <div className="absolute -top-16 -right-16 w-64 h-64 bg-red-500/30 rounded-full blur-3xl" aria-hidden />
          <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-emerald-400/20 rounded-full blur-3xl" aria-hidden />

          <div className="relative grid md:grid-cols-[1.2fr_1fr] gap-6 md:gap-8 p-5 sm:p-8 md:p-10 items-center">
            <div>
              <span className="inline-block bg-red-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow mb-2 md:mb-3">
                Compliance done for you
              </span>
              <h2 className="text-xl sm:text-2xl md:text-4xl font-bold leading-tight mb-2 md:mb-3">
                Struggling with paperwork, permits or clearances?
              </h2>
              <p className="text-blue-100 text-sm md:text-base mb-4 md:mb-5 max-w-lg">
                Our team of Australian transport professionals handles it — so you stay on the road, not on the phone.
              </p>
              <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-6 max-w-lg">
                {items.map((i) => {
                  const Icon = i.icon;
                  return (
                    <div key={i.label} className="flex items-center gap-2 text-sm bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2">
                      <Icon className="w-4 h-4 text-red-300 flex-shrink-0" />
                      <span className="font-medium">{i.label}</span>
                    </div>
                  );
                })}
              </div>
              <Link
                to="/compliance"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-3 rounded-full shadow-lg transition-all hover:shadow-xl"
                data-testid="home-compliance-cta"
              >
                See how we can help
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            <div className="hidden md:flex justify-center">
              <div className="relative">
                <div className="w-56 h-56 rounded-full bg-red-500/20 backdrop-blur-sm flex items-center justify-center">
                  <ShieldCheck className="w-24 h-24 text-white/80" strokeWidth={1.2} />
                </div>
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-white text-[#1e3a5f] text-xs font-bold px-4 py-1.5 rounded-full shadow-lg">
                  Australian experts
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceServicesStrip;
